<script setup>

import { useElementSize } from '@vueuse/core'

const cover = ref(null)
const { width } = useElementSize(cover)

const props = defineProps({
  attrs: {
    type: Object,
  },
	id: {
		type: Number
	}
})

const randomColor = ref(null)

const colors = ref([
	'magenta',
	'gold',
	'lilac',
	'cyan',
	'red',
	'green'
])

onMounted(() => {
	randomColor.value = getRandomColor()
})

const getRandomColor = () => {
	return colors.value[Math.floor(Math.random()*colors.value.length)]
}

</script>

<template>
	<div>
		<a :href="attrs.url" :target="attrs.newtab ? '_blank' : '_self'">
		<div
				ref="cover"
				class="cover aspect-square dark:bg-dark8 bg-lightBg8 tracking-[-0.36px] xl:tracking-[-0.48px] leading-[130%] fvs600"
				:class="`text-${randomColor} p-[${Math.round(width/14)}px]`"	
			>
			<span class="tracking-[-0.36px] xl:tracking-[-0.48px] leading-[130%] fvs600" :class="`text-[${Math.round(width/14)}px]`">{{ attrs.title }}</span>
		</div>
		</a>
	</div>
</template>

